// extracted by mini-css-extract-plugin
module.exports = {"button":"sub-hero-module--button--2frOT","subHero":"sub-hero-module--sub-hero--3wg2J","title":"sub-hero-module--title--yBb43","subtitle":"sub-hero-module--subtitle--3udcB"};